import { getBusinessUnits } from '@/api/business-units'
import {
  Division,
  DIVISION,
  Hub,
  HUB,
  Organization,
  ORGANIZATION,
  Team,
  TEAM,
} from '@/models/business-unit'
import { orderBy } from 'lodash'

export const RECEIVE_BUSINESS_UNITS = 'RECEIVE_BUSINESS_UNITS'
export const LOADING_BUSINESS_UNITS = 'LOADING_BUSINESS_UNITS'
export const ERROR_LOADING = 'ERROR_LOADING'

const state = {
  all: {},
  loading: false,
  error: null,
}

export const getters = {
  // Cache base getter for all business units to avoid repeated Object.values calls
  _allBusinessUnits: (state) => {
    return Object.values(state.all)
  },
  getAllBusinessUnits: (state, getters) =>
    orderBy(getters._allBusinessUnits, [(bu) => bu.name.toLowerCase()]),
  getAllOrganizations: (_, getters) =>
    getters.getAllBusinessUnits.filter((bu) => bu.type === ORGANIZATION),
  getManagedOrganizations: (_, getters) => (orgId) =>
    getters.getAllOrganizations.filter((org) => org.ownerId === orgId || org.id === orgId),
  getAllHubs: (_, getters) => getters.getAllBusinessUnits.filter((bu) => bu.type === HUB),
  getAllDivisions: (_, getters) => getters.getAllBusinessUnits.filter((bu) => bu.type === DIVISION),
  getAllTeams: (_, getters) => getters.getAllBusinessUnits.filter((bu) => bu.type === TEAM),
  getBusinessUnitById: (state) => (id) => state.all[id],
  getHierarchyLevel: (state, getters) => (id, level) => {
    const bu = state.all[id]
    if (!bu) return null
    if (bu.type === level) return bu
    const owner = getters.getBusinessUnitById(bu.ownerId)
    return getters.getHierarchyLevel(owner?.id, level)
  },
  getLoading: (state) => state.loading,
}

export const actions = {
  async fetchBusinessUnits({ commit }) {
    try {
      commit(LOADING_BUSINESS_UNITS)
      const { data } = await getBusinessUnits()
      commit(RECEIVE_BUSINESS_UNITS, data)
    } catch (err) {
      commit(ERROR_LOADING, err)
    }
  },
}

export const mutations = {
  [LOADING_BUSINESS_UNITS](state) {
    state.loading = true
  },
  [RECEIVE_BUSINESS_UNITS](state, data) {
    const byId = {}

    data.forEach((json) => {
      let entry = null
      switch (json.type) {
        case ORGANIZATION:
          entry = Object.freeze(new Organization(json))
          break
        case HUB:
          entry = Object.freeze(new Hub(json))
          break
        case DIVISION:
          entry = Object.freeze(new Division(json))
          break
        case TEAM:
          entry = Object.freeze(new Team(json))
          break
        default:
          entry = null
      }

      if (entry !== null) {
        byId[json.id] = entry
      }
    })

    state.all = Object.freeze(byId)
    state.loading = false
  },
  [ERROR_LOADING](state, err) {
    state.error = err
    state.loading = false
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
